/*
  Constants shared by the ticket-import file parser, payload builders and
  result renderers. Centralised so the validation flow, booking flow and UI
  all agree on the set of fields and labels.
*/

export const REQUIRED_HEADERS = [
    'Journey Date',
    'Route',
    'Boarding Point',
    'Drop Off Point',
    'Pnr Number',
    'Name',
    'Phone number',
    'Seat Number',
    'Fare',
    'Service Number',
    'Status',
];

export const OPTIONAL_HEADERS = [
    'Coach',
    'Email',
    'Net Amount',
    'Booked By',
    'Branch',
    'Booked On',
    'Remarks',
    'Discount',
    'Issued By',
    'Offer Discount',
    'Cancelled By',
    'Document Number',
    'Commission',
    'Category',
    'gst',
    'Service Status',
    'Cancelled On',
    'Issued On',
    'Additional Fare',
    'Booked For',
    'Drivers',
];

// Fields every ticket row must carry to be eligible for booking. Order is
// preserved for predictable error messages.
export const MANDATORY_ROW_FIELDS = [
    { key: 'journeyDate', label: 'Journey Date' },
    { key: 'route', label: 'Route' },
    { key: 'boardingPoint', label: 'Boarding Point' },
    { key: 'dropOffPoint', label: 'Drop Off Point' },
    { key: 'pnr', label: 'Pnr Number' },
    { key: 'name', label: 'Name' },
    { key: 'phoneNumber', label: 'Phone number' },
    { key: 'seatNumber', label: 'Seat Number' },
];

// Display metadata for each per-seat verdict returned by the server.
export const SEAT_STATUS_LABELS = {
    available: { color: 'green', text: 'Available' },
    booked: { color: 'red', text: 'Already booked' },
    blocked_by_ticket: { color: 'red', text: 'Blocked by another ticket' },
    admin_blocked: { color: 'volcano', text: 'Admin-blocked' },
    not_in_layout: { color: 'red', text: 'Not in bus layout' },
    invalid: { color: 'red', text: 'Invalid seat' },
    duplicate_in_ticket: { color: 'red', text: 'Duplicate within PNR' },
    duplicate_in_import: { color: 'red', text: 'Duplicate within file' },
    trip_not_found: { color: 'red', text: 'Trip not matched' },
    same_pnr_imported: { color: 'blue', text: 'Already imported under same PNR' },
    reassigned: { color: 'cyan', text: 'Reassigned' },
};
